import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedFeatureAffiliationAccessModule } from '../lib/shared-feature-affiliation-access.module'
import { AffiliationAccessDocsComponent } from './affiliation-access-docs/affiliation-access-docs.component'
import { AffiliationAccessExampleComponent } from './affiliation-access-docs/affiliation-access-example.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedFeatureAffiliationAccessModule
  ],
  declarations: [
    AffiliationAccessDocsComponent,
    AffiliationAccessExampleComponent
  ],
  exports: [
    AffiliationAccessDocsComponent
  ]
})
export class SharedFeatureAffiliationAccessDocsModule {}
